import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles/icon.scss';

/**
* @todo Move icons-list.scss, images and styles to this component
* after removing the old Icon class component.
*/

const Icon = ({ name, size = 'size-28x28', content }) => {
    if (!name) {
        return null;
    }

    const tabIconClassName = classNames(
        'bb-icon',
        `bb-icon--${name}`,
        `bb-icon--${size}`,
    );

    return (
        <div className={tabIconClassName}>
            {content}
        </div>
    );
};

Icon.propTypes = {
    name        : PropTypes.string,
    size        : PropTypes.string,
    content     : PropTypes.string,
};

export default Icon;
